<mat-toolbar color="primary" class="toolBar" *ngIf="gameStatus">
  Memorama - Aivo Desafío
  <app-countdown [togglePlayer]="toggle" (togglePlayertEmitter)="togglePlayertEmitter()"></app-countdown>
  <button mat-raised-button
          color="warn"
          (click)="restartGame()"
          class="toolBar__button">
    Reiniciar partida
  </button>
</mat-toolbar>

<div class="container">
  <div class="container__players">
    <app-player *ngFor="let player of players" [data]="player"></app-player>
  </div>
  <div class="card__grid">
    <app-card *ngFor="let card of cards, let id=index"
              [data]="card"
              (clickPropagate)="propagateClick(id)">
    </app-card>
  </div>
  <p class="container__footer">2021 - Cayun Diego - Prueba técnica Frontend - Aivo</p>
</div>

<app-popup-dialog *ngIf="!gameStatus"
                  (clickPropagate)="startGame()"
                  [players]='players'
                  ></app-popup-dialog>
